import React from "react";

import Navigation from "../header";
import ErrorMessage from "../errorMessage";
import { useRouteError } from "react-router-dom";
import { Container } from "@mui/material";

const Error = () => {
	let error = useRouteError();
	console.error(error);

	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<ErrorMessage>
					<p>Something went wrong.</p>
					<p>If the issue persists please contact your administrator.</p>
				</ErrorMessage>

			</Container>
		</>
	);
};

export default Error;
